module.exports = __webpack_public_path__ + "img/noiseStandards.96ea8d30.png";